import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconNames } from '../../common/constants/icon-names';
import { DateWithTimezones } from '../../common/models/status-history-chain.model';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { DateWithProfileAndLocalTimezoneComponent } from '../profile-and-local-date/date-with-profile-and-local-timezone.component';
import { DISPLAY_DATE_FORMAT } from '../../common/constants/date-config';

@Component({
  selector: 'ui-profile-and-local-dates-with-divider',
  imports: [CommonModule, IntrackFeatureModule, SvgIconComponent, DateWithProfileAndLocalTimezoneComponent],
  templateUrl: './profile-and-local-dates-with-divider.component.html',
  styleUrls: ['./profile-and-local-dates-with-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileAndLocalDatesWithDividerComponent {
  @Input() label: string;
  @Input() startDate: DateWithTimezones;
  @Input() endDate: DateWithTimezones;

  @Input() arrivalDeviation: string;
  @Input() departureDeviation: string;

  @Input() showWarningIcon: boolean;
  @Input() warningMessage: string;

  dateFormat = DISPLAY_DATE_FORMAT;
  iconNameList = IconNames;
}
